import styled from '@emotion/styled';
import { GeneralStyles } from '../../components/styles/generalStyles';

const theme = { ...GeneralStyles };

export const ProjectsContainer = styled.section`
  background: ${theme.colors.brown};
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
  align-items: center;
  padding: ${theme.spacings.yotta} 0;

  a {
    color: ${theme.colors.white};
  }
`;
